import { OnInit } from '@angular/core';
import { chain } from 'lodash';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../core';
import { Category, TabCategory } from '../../documents';
import { Site } from '../../sites/site';

export abstract class DocumentsTabsCategoriesComponentBase implements OnInit {
    public tabsCategories: Observable<TabCategory[]>;

    constructor(
        protected readonly urlBuilder: UrlBuilder,
    ) {}

    public ngOnInit() {
        this.tabsCategories = this.createTabsCategories();
    }

    protected abstract createTabsCategories() : Observable<TabCategory[]>;

    protected createTabs(site: Site, category: Category, childCategories: Category[]): TabCategory[] {
        const tabs = chain(childCategories)
            .map(childCategory => {
                const url = this.createTabUrl(site, category, childCategory);

                return { name: childCategory.name, url } as TabCategory;
            }).value();

        return tabs;
    }

    private createTabUrl(site: Site, category: Category, childCategory: Category): string[] {
        const url = this.urlBuilder
            .esa()
            .site(site)
            .documents(category);

        return url.category(childCategory).url();
    }
}